var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filter/filter_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 10.6249C11.6398 10.6246 10.3595 11.6697 10.0625 13.1249H0.625V14.3749H10.0625C10.3582 15.8314 11.6388 16.8781 13.125 16.8781C14.6112 16.8781 15.8918 15.8314 16.1875 14.3749H19.375V13.1249H16.1875C15.8905 11.6697 14.6102 10.6246 13.125 10.6249ZM13.125 15.625C12.3666 15.625 11.6829 15.1681 11.3927 14.4675C11.1025 13.7669 11.2629 12.9604 11.7992 12.4241C12.3354 11.8879 13.1419 11.7275 13.8425 12.0177C14.5432 12.3079 15 12.9916 15 13.75C15 14.7855 14.1605 15.625 13.125 15.625ZM9.9375 5.62496C9.64175 4.16851 8.36118 3.12183 6.875 3.12183C5.38882 3.12183 4.10825 4.16851 3.8125 5.62496H0.625V6.87496H3.8125C4.10825 8.33141 5.38882 9.37809 6.875 9.37809C8.36118 9.37809 9.64175 8.33141 9.9375 6.87496H19.375V5.62496H9.9375ZM6.875 8.12494C5.83947 8.12494 5 7.28547 5 6.24994C5 5.2144 5.83947 4.37494 6.875 4.37494C7.91053 4.37494 8.75 5.2144 8.75 6.24994C8.75 7.28547 7.91053 8.12494 6.875 8.12494Z",
    fill: "#2495F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.015363f625f164a84202e6326c3aa1f0.svg";
export { ForwardRef as ReactComponent };